import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=fb851464"
import script from "./OrderRow.vue?vue&type=script&lang=js"
export * from "./OrderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports